import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var MESSAGES_ENDPOINT = "".concat(constants.API_URL, "/messages");
var SEARCH_USERS_ENDPOINT = "".concat(constants.API_URL_V1, "/users/search");
var MESSAGES_LIST_ENDPOINT_V1 = "".concat(constants.API_URL_V1, "/users/me/messages");
var MESSAGES_UNREAD_COUNT_ENDPOINT = "".concat(constants.API_URL, "/users/me/messages/unread-count");

function listMessages() {
  return _listMessages.apply(this, arguments);
}

function _listMessages() {
  _listMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var label,
        response,
        _args9 = arguments;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            label = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : constants.MESSAGES.INBOX;
            _context9.next = 3;
            return http.get("".concat(MESSAGES_LIST_ENDPOINT_V1, "?label=").concat(label));

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _listMessages.apply(this, arguments);
}

function getUsers(_x) {
  return _getUsers.apply(this, arguments);
}

function _getUsers() {
  _getUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref) {
    var params, _response, response;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            params = _ref.params;

            if (!(params.courseId === "all")) {
              _context10.next = 6;
              break;
            }

            _context10.next = 4;
            return http.get(SEARCH_USERS_ENDPOINT);

          case 4:
            _response = _context10.sent;
            return _context10.abrupt("return", _response);

          case 6:
            _context10.next = 8;
            return http.get(SEARCH_USERS_ENDPOINT, {
              params: params
            });

          case 8:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _getUsers.apply(this, arguments);
}

function getAcademicYear(_x2) {
  return _getAcademicYear.apply(this, arguments);
}

function _getAcademicYear() {
  _getAcademicYear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref2) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            schoolId = _ref2.schoolId;
            _context11.next = 3;
            return http.get("".concat(constants.API_URL, "/schools/").concat(schoolId, "/semesters/active"));

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _getAcademicYear.apply(this, arguments);
}

function getUnreadCount() {
  return _getUnreadCount.apply(this, arguments);
}

function _getUnreadCount() {
  _getUnreadCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return http.get(MESSAGES_UNREAD_COUNT_ENDPOINT);

          case 2:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _getUnreadCount.apply(this, arguments);
}

function getAllAttachments(_x3) {
  return _getAllAttachments.apply(this, arguments);
}

function _getAllAttachments() {
  _getAllAttachments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref3) {
    var messageId, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            messageId = _ref3.messageId, onDownloadProgress = _ref3.onDownloadProgress;
            _context13.next = 3;
            return http.get("".concat(MESSAGES_ENDPOINT, "/").concat(messageId, "/attachments"), {
              responseType: "blob",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _getAllAttachments.apply(this, arguments);
}

function getSeenCount(_x4) {
  return _getSeenCount.apply(this, arguments);
}

function _getSeenCount() {
  _getSeenCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref4) {
    var messageId, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            messageId = _ref4.messageId;
            _context14.next = 3;
            return http.get("".concat(MESSAGES_ENDPOINT, "/").concat(messageId, "/seen"));

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _getSeenCount.apply(this, arguments);
}

var markThreadAsSeen = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
    var messageId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            messageId = _ref5.messageId;
            _context.next = 3;
            return http.post("".concat(MESSAGES_ENDPOINT, "/").concat(messageId, "/mark-seen"));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function markThreadAsSeen(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

var editMessage = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref7) {
    var messageId, data, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            messageId = _ref7.messageId, data = _ref7.data;
            _context2.next = 3;
            return http.patch("".concat(MESSAGES_ENDPOINT, "/").concat(messageId, "/edit"), data);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function editMessage(_x6) {
    return _ref8.apply(this, arguments);
  };
}();

var restoreBulkMessages = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref9) {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = _ref9.data;
            _context3.next = 3;
            return http.post("".concat(MESSAGES_ENDPOINT, "/restore-thread-bulk"), data);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function restoreBulkMessages(_x7) {
    return _ref10.apply(this, arguments);
  };
}();

var getMessageThreadV1 = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref11) {
    var messageId, params, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            messageId = _ref11.messageId, params = _ref11.params;
            _context4.next = 3;
            return http.get("".concat(constants.API_URL_V1, "/messages/").concat(messageId, "/thread"), {
              params: params
            });

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getMessageThreadV1(_x8) {
    return _ref12.apply(this, arguments);
  };
}();

var deleteBulkMessages = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref13) {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            data = _ref13.data;
            _context5.next = 3;
            return http.post("".concat(MESSAGES_ENDPOINT, "/trash-thread-bulk"), data);

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function deleteBulkMessages(_x9) {
    return _ref14.apply(this, arguments);
  };
}();

var createMessageV1 = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref15) {
    var params, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            params = _ref15.params, data = _ref15.data, onUploadProgress = _ref15.onUploadProgress;
            _context6.next = 3;
            return http.post("".concat(constants.API_URL_V1, "/messages"), data, {
              params: params,
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function createMessageV1(_x10) {
    return _ref16.apply(this, arguments);
  };
}();

var getMessageReceivers = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref17) {
    var messageId, params, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            messageId = _ref17.messageId, params = _ref17.params;
            _context7.next = 3;
            return http.get("".concat(constants.API_URL, "/messages/").concat(messageId, "/receivers"), {
              params: params
            });

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getMessageReceivers(_x11) {
    return _ref18.apply(this, arguments);
  };
}();

var getMessageBCCs = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref19) {
    var messageId, params, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            messageId = _ref19.messageId, params = _ref19.params;
            _context8.next = 3;
            return http.get("".concat(constants.API_URL, "/messages/").concat(messageId, "/bccs"), {
              params: params
            });

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getMessageBCCs(_x12) {
    return _ref20.apply(this, arguments);
  };
}();

export default {
  listMessages: listMessages,
  getUsers: getUsers,
  getAcademicYear: getAcademicYear,
  getUnreadCount: getUnreadCount,
  getAllAttachments: getAllAttachments,
  getSeenCount: getSeenCount,
  markThreadAsSeen: markThreadAsSeen,
  editMessage: editMessage,
  restoreBulkMessages: restoreBulkMessages,
  getMessageThreadV1: getMessageThreadV1,
  deleteBulkMessages: deleteBulkMessages,
  createMessageV1: createMessageV1,
  getMessageReceivers: getMessageReceivers,
  getMessageBCCs: getMessageBCCs
};